import React, { createContext, useState, useContext, useEffect } from 'react';

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [adminToken, setAdminToken] = useState(null);
  const [adminLoading, setAdminLoading] = useState(true);

  const API_BASE_URL = 'https://question-manager-backend.onrender.com/api';

   useEffect(() => {
    const savedAdmin = localStorage.getItem('admin');
    const savedAdminToken = localStorage.getItem('adminToken');
    
    if (savedAdmin && savedAdminToken) {
      setAdmin(JSON.parse(savedAdmin));
      setAdminToken(savedAdminToken);
    }
    setAdminLoading(false);
  }, []);

   const adminLogin = async (email, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'فشل تسجيل الدخول للإدارة');
      }

      const data = await response.json();
      
       setAdmin(data.user);
      setAdminToken(data.token);
      localStorage.setItem('admin', JSON.stringify(data.user));
      localStorage.setItem('adminToken', data.token);
      
      return { success: true, data };
    } catch (error) {
      console.error('Admin login error:', error);
      return { success: false, error: error.message };
    }
  };

   const adminLogout = () => {
    setAdmin(null);
    setAdminToken(null);
    localStorage.removeItem('admin');
    localStorage.removeItem('adminToken');
  };

   const isAdminAuthenticated = () => {
    return !!admin && !!adminToken;
  };

  const value = {
    admin,
    adminToken,
    adminLogin,
    adminLogout,
    isAdminAuthenticated,
    adminLoading
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};